<!--
  ClientNotesField.vue -- auto-saving freeform Distributor-side notes.

  The notes column ALREADY exists on the Client model (added in
  ``route_fork_schema_039``) -- this component is the workspace's
  editor for it. Writes go to the SAFRS PATCH surface (``/api/clients/
  <id>`` with attributes.notes), which is cap-gated on ``client.update``.

  Notes are Distributor-side ONLY. The recipient (Store Owner) never
  sees them. Placeholder copy makes this explicit so the Distributor
  doesn't accidentally write something they'd be embarrassed to have
  the Client read.

  Auto-save lives in the Pinia store's ``updateNotes`` action with a
  debounce (NOTES_DEBOUNCE_MS). The per-Client save state surfaces
  inline as "Saving..." / "Saved" / "Could not save".
-->
<template>
    <div class="cnf" data-testid="client-notes-field">
        <textarea
            v-model="text"
            class="cnf__textarea"
            data-testid="client-notes-textarea"
            placeholder="Add notes only your team will see -- context about contacts, preferences, history"
            rows="6"
            @input="onInput"
        />
        <p class="cnf__status" data-testid="client-notes-status">
            <span v-if="state === 'saving'">Saving...</span>
            <span v-else-if="state === 'saved'" class="cnf__status--ok">
                Saved
            </span>
            <span v-else-if="state === 'pending'">Editing...</span>
            <span v-else-if="state === 'error'" class="cnf__status--err">
                Could not save. Try again.
            </span>
        </p>
    </div>
</template>

<script>
import { useClientsWorkspaceStore } from '@/stores/clientsWorkspace'

export default {
    name: 'ClientNotesField',
    props: {
        clientId: { type: [Number, String], required: true },
        initialValue: { type: String, default: '' },
    },
    data() {
        return {
            text: this.initialValue,
        }
    },
    watch: {
        initialValue(v) {
            // Refresh from parent when a fresh client load arrives.
            this.text = v
        },
    },
    computed: {
        store() {
            return useClientsWorkspaceStore()
        },
        state() {
            return this.store.notesSaveState?.[String(this.clientId)] || 'idle'
        },
    },
    methods: {
        onInput() {
            this.store.updateNotes(this.clientId, this.text)
        },
    },
}
</script>

<style scoped>
.cnf__textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--tf-border, #d0d4dc);
    border-radius: var(--tf-radius-xs, 4px);
    font-size: 13px;
    font-family: inherit;
    color: var(--tf-fg-1);
    background: var(--tf-bg, #fff);
    resize: vertical;
    min-height: 100px;
}
.cnf__textarea:focus {
    outline: none;
    border-color: var(--tf-accent, #2c5fff);
}
.cnf__status {
    margin: 6px 0 0;
    font-size: 12px;
    color: var(--tf-fg-3, #6b7280);
    min-height: 16px;
}
.cnf__status--ok {
    color: #14571c;
}
.cnf__status--err {
    color: #c0392b;
}
</style>
